import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./store";
import { useEffect } from "react";
import { fetchUserProfile } from "./store/authSlice";
import Login from "./pages/Login";
import MainLayout from "./components/layout/MainLayout";
import ContestSupport from "./pages/Contest/Contest";
import ContestDashboard from "./pages/Contest/ContestDashboard";
import DataImportExportHome from "./pages/DataImportExportHome";
import DataImport from "./pages/DataImportExportHome";
import ContestList from "./pages/Contest/Contest-list";
import Home from './pages/Home'
import Winnerlist from "./pages/Contest/winners-list";
import PlaceWinnerList from "./pages/Contest/place-winner-list";
import ParticipantsList from "./pages/Contest/ParticipantsList";
import ParticipantDetails from "./pages/Contest/ParticipantDetails";
import ImportPage from "./pages/DataImport";
import ExportPage from "./pages/DataExport";
import OrganiseHomeScreenPage from "../src/pages/OrgHomeScreen/OrganiseHomeScreen";
import SectionPage from "../src/pages/OrgHomeScreen/Section";
import SubsectionPage from "../src/pages/OrgHomeScreen/Subsection";
import RearrangeListsHome from "./pages/Rearrange Lists/rearrange-list-home";
import RearrangeCity from "./pages/Rearrange Lists/rearrange-city-list";
import RearrangePOI from "./pages/Rearrange Lists/rearrange-poi-list";
import RearrangeTripPOI from "./pages/Rearrange Lists/rearrange-trippoi-list";
import NotificationHomePage from "./pages/NotificationManagement/Notification-Management-Home";
import NotificationCreateMobile from "./pages/NotificationManagement/Notification-create-mobile";
import NotificationMobileList from "./pages/NotificationManagement/Notification-mobile-list";
import CreateGeofencePage from "../src/pages/NotificationManagement/Notification-create-geofence";
import NotificationListGeofencePage from "../src/pages/NotificationManagement/Notification-list-geofence";
import FAQManagement from "./pages/FAQS/ListFAQ";
import CreateFAQ from "./pages/FAQS/CreateFAQ";
import FAQSListListsHome from "./pages/FAQS/faqs-Management-Home";
import MobileOTPByPassPage from "../src/pages/OTP/MobileOTPByPass";

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated, loading } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(fetchUserProfile()); // 🔹 try restoring session
  }, [dispatch]);

  // if (loading) {
  //   return <div>Loading...</div>; // simple loader
  // }

  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<Login />} />

      {/* Protected Routes */}
      {isAuthenticated ? (
        <Route path="/" element={<MainLayout />}>
          <Route path="Home" element={<Home />} />
          <Route path="contest-dashboard" element={<ContestDashboard />} />
          <Route path="contest-support/create" element={<ContestSupport />} />
          <Route path="contest-support/list" element={<ContestList />} />
          <Route path="contest" element={<ContestSupport />} />
          <Route path="contest-support/winner-list" element={<Winnerlist />} />
          <Route path="/place-winner-list" element={<PlaceWinnerList />} />
          <Route path="/participants" element={<ParticipantsList />} />
          <Route path="participantDetails" element={<ParticipantDetails />} />
          <Route index element={<Navigate to="/contest-dashboard" replace />} />
          <Route path="data-imp-exp-home" element={<DataImportExportHome />} />
          {/* Legacy route with contestId (kept for deep links) */}
          <Route path="contest-support/edit/:id" element={<ContestSupport />} />
          <Route path="contest-support/edit" element={<ContestSupport />} />
          <Route path="contest-support/view" element={<ContestSupport />} />
          <Route path="data-import-page" element={<ImportPage  />} />
          <Route path="data-export-page" element={<ExportPage  />} />
          <Route path="organizehome" element={<OrganiseHomeScreenPage  />} />
          <Route path="section-subsection" element={<SectionPage  />} />
          <Route path="subsection" element={<SubsectionPage  />} />
          <Route path="rearrange-lists-home" element={<RearrangeListsHome />} />
          <Route path="rearrange-city-lists" element={<RearrangeCity />} />
          <Route path="rearrange-poi-lists" element={<RearrangePOI />} />
          <Route path="rearrange-trippoi-lists" element={<RearrangeTripPOI />} />
          <Route path="Notification-Management-Home" element={<NotificationHomePage />} />
          <Route path="Notification-create-mobile/create" element={<NotificationCreateMobile />} />
          <Route path="Notification-mobile-list" element={<NotificationMobileList />} />
          <Route path="Notification-create-mobile/:mode/:id?" element={<NotificationCreateMobile />} />
          <Route path="CreateGeofenceNotification" element={<CreateGeofencePage />} />
          <Route path="ListGeofenceNotification" element={<NotificationListGeofencePage />} />
          <Route path="faqs-Management-Home" element={<FAQSListListsHome />} />
          <Route path="Create-FAQ" element={<CreateFAQ />} /> 
          <Route path="CreateFAQ/:mode/:faq?" element={<CreateFAQ />} />
          <Route path="FAQ-List" element={<FAQManagement />} />
          <Route path="MobileOTP" element={<MobileOTPByPassPage />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
}

export default App;
